import path from 'path'
import findLast from 'lodash.findlast'

export const state = () => ({
  territory: 'en-gb', // ISO 639-1 (language-region)
  website: '', // website (detects nearest website)
  path: '', // story path
  cache: '', // space version id
  version: '', // article version id
  release: null, // storyblok release id
  space: {}, // space stored object
  mq: null, // media query
  size: null, // current media query index
  inEditor: null, // whether we're in Storybloks editor.
  redirects: [], // handle CMS based redirects for invalid pages.
})

export const getters = {
  getRedirects(state) {
    return state.redirects
  },
  getMq(state) {
    return state.mq
  },
  getRegion(state) {
    return state.region
  },
  getInEditor(state) {
    return state.inEditor
  },
  getPath(state) {
    return state.path
  },
}

export const mutations = {
  SET_REDIRECTS(state, payload) {
    state.redirects = payload
  },
  SET_SIZE(state, value) {
    state.size = value
  },
  SET_MEDIA(state, value) {
    state.mq = value
  },
  SET_VERSION(state, payload) {
    state.version = payload
  },
  SET_RELEASE(state, payload) {
    state.release = payload
  },
  SET_CACHE(state, payload) {
    state.cache = payload
  },
  SET_SPACE(state, payload) {
    state.space = payload
  },
  SET_TERRITORY(state, payload) {
    state.territory = payload
  },
  SET_IN_EDITOR(state, payload) {
    state.inEditor = payload
  },
  SET_WEBSITE(state, payload) {
    state.website = payload
  },
  SET_PATH(state, route) {
    if (!route.match(/^\/?[a-zA-Z]{2}-[a-zA-Z]{2}/g)) {
      route = path.join(state.territory, route)
    }
    state.path = route.replace(/^\/+/g, '')
  },
}

export const actions = {
  async getRedirects({ commit, dispatch, state }, payload) {
    const redirects = await this.$storyapi
      .get('cdn/datasource_entries?datasource=redirects', {
        per_page: 1000,
        cv: Date.now(),
      })
      .then((res) => {
        commit('SET_REDIRECTS', res.data.datasource_entries)
      })
      .catch((error) => {
        return error
      })
    return redirects
  },
  async setDisplayViewport({ commit, dispatch, state }) {
    if (process.browser) {
      dispatch('loading/startBusyState', null, { root: true })
      const mq = [
        {
          query: window.matchMedia(`(min-width: 0px) and (max-width: 575px)`),
          size: 0,
        }, // xs
        {
          query: window.matchMedia(`(min-width: 576px) and (max-width: 767px)`),
          size: 1,
        }, // sm
        {
          query: window.matchMedia(`(min-width: 768px) and (max-width: 991px)`),
          size: 2,
        }, // md
        {
          query: window.matchMedia(
            `(min-width: 992px) and (max-width: 1199px)`
          ),
          size: 3,
        }, // lg
        { query: window.matchMedia(`(min-width: 1200px)`), size: 4 }, // xl
      ]
      const entry = findLast(mq, (item) => {
        return item.query.matches === true
      })
      if (entry.size !== state.size) {
        await commit('SET_MEDIA', mq)
        await commit('SET_SIZE', entry.size)
      }
      dispatch('loading/stopBusyState', null, { root: true })
    }
  },
  async getSpace({ commit, dispatch, state }, payload) {
    dispatch('loading/startBusyState', null, { root: true })
    await this.$storyapi
      .get('cdn/spaces/me', {
        version: payload.version,
        cv: Date.now(),
      })
      .then((res) => {
        commit('SET_SPACE', res.data.space)
        commit('SET_CACHE', res.data.space.version)
      })
      .catch((error) => {
        return error
      })
      .then(() => {
        // final
        dispatch('loading/stopBusyState', null, { root: true })
      })
  },
}
